// The clinical reading registry - which measurements exist, the unit each is recorded in, and the
// label it's displayed under.
//
// kraken's `App\Support\ReadingTypes` is the source of truth and serves this over `/reading-types`;
// this list is the fallback used before that call resolves and if it fails, so the UI is never
// blank. Keep the two in step.
//
// Note that `type` is the string stored in `readings.type` and matched verbatim by the backend, so
// it is not a display value - 'insulin' names the chart a blood glucose is taken for rather than the
// measurement, which is exactly why the label is carried separately.
export const READING_TYPES = [
    { type: 'insulin', unit: 'BGL', label: 'BGL', trend: true },
    { type: 'Blood Test', unit: 'INR', label: 'INR', trend: true },
    { type: 'Sedation', unit: 'Score', label: 'Sedation', trend: true },
    { type: 'Serum Creatinine', unit: 'µmol/L', label: 'Serum Creatinine', trend: true },
    { type: 'Height', unit: 'cm', label: 'Height', trend: false },
    { type: 'Weight', unit: 'kg', label: 'Weight', trend: false },
];

// The two pairs the sliding-scale administration path writes. Exported by type so callers can't
// assemble their own and drift from the registry.
export const BGL_READING = { type: 'insulin', unit: 'BGL' };
export const INR_READING = { type: 'Blood Test', unit: 'INR' };

// Filter buttons for the readings view: clinical observations only, height/weight excluded to match
// Person::top5Readings().
export function trendReadingOptions(types) {
    return (types && types.length ? types : READING_TYPES)
        .filter(entry => entry.trend)
        .map(entry => ({ label: entry.label, value: entry.type }));
}

// The label a stored reading should be displayed under, falling back to the raw type.
export function readingLabelFor(type, types) {
    const found = (types && types.length ? types : READING_TYPES).find(entry => entry.type === type);
    return found ? found.label : type;
}
